import React, { useEffect, useState } from "react";
import shape6 from "../../images/shape-6.png";
import shape24 from "../../images/shape-24.png";
import shape23 from "../../images/shape-23.png";
import shape5 from "../../images/shape-5.png";
import shape8 from "../../images/shape-8.png";
import author from "../../images/author-03.jpg";
import blog1 from "../../images/blog1.jpg";
import blog2 from "../../images/blog2.png";
import blog3 from "../../images/blog3.jpg";
import blog4 from "../../images/blog4.jpg";
import shape14 from "../../images/shape-14.png";
import shape12 from "../../images/shape-12.png";

import shape21 from "../../images/shape-21.png";
import shape22 from "../../images/shape-22.png";
import Accordion from "react-bootstrap/Accordion";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
import { useParams } from "react-router-dom";
import axios from "axios";
import { format } from "date-fns";
const Blog4 = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);
	const [blog, setBlog] = useState([]);
	let { id } = useParams();

	async function getBlogs() {
		let { data } = await axios.get(
			`https://maps-medics-be.onrender.com/show_blog/` + id
		);
		setBlog(data);

		console.log(data);
	}
	useEffect(() => {
		getBlogs();
	}, []);
	return (
		<>
			{/* <Navbar/> */}
			<div
				className="section section-padding"
				style={{ paddingTop: "30px", paddingBottom: "64px" }}
			></div>
			<div class="section pageBanner">
				<div
					style={{
						backgroundColor: "rgba(0,0,0,0.4)",
						width: "100%",
						height: "100%",
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
					}}
				>
					<div
						class="container"
						style={{
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
						}}
					>
						<div class="page-banner-content">
							{/* <ul class="breadcrumb">
                 <li><a>Home</a></li>
                 <li class="active">Blog</li>
             </ul> */}
							{/* <h2 class="title" style={{color:'#fff'}}> </h2> */}
						</div>
					</div>
				</div>
			</div>
			<div className="container ">
				<div className="row" style={{display:"flex", justifyContent:"center"}}>
					<h2 class="title" style={{ color: "#000", paddingTop: "3%" }}>
						
						{blog.title} <span> {blog.date && format(new Date(blog.date), "MMMM dd, yyyy") }</span>
					</h2>
					<div className="col-md-6" style={{  paddingTop: "3%" }}>
						<img src={blog.image} />
			 			<br/>
			 			<br/>
						<h5>
							<i
								class="fa-solid fa-check-double"
								style={{ color: "#ffc600" }}
							></i>
							{blog.text && blog.text.split("\n").map((one)=> <>{one}<br/></>)}
						</h5>
					</div>
				</div>
			</div>
			<div class="section section-padding">
				<div class="container">
					<div class="contact-wrapper">
						<div class="row align-items-center">
							<div class="col-lg-12">
								<div class="contact-info">
									<img
										class="shape animation-round"
										src={shape12}
										alt="Shape"
									/>
									<h2>Leave A Reply</h2>

									<div class="single-contact-info">
										<div class="info-content">
											<h6 class="title">Comment *</h6>

											<textarea
												type="text"
												className="form-control"
												placeholder="Comment"
											/>
										</div>
									</div>

									<div class="single-contact-info">
										<div class="info-content">
											<h6 class="title">Name *</h6>

											<input
												type="text"
												className="form-control"
												placeholder="Name"
											/>
										</div>
									</div>

									<div class="single-contact-info">
										<div class="info-content">
											<h6 class="title">Email *</h6>
											<input
												type="text"
												className="form-control"
												placeholder="Email"
											/>
										</div>
									</div>

									<div class="single-contact-info">
										<div class="info-content">
											<h6 class="title">Website</h6>
											<input
												type="text"
												className="form-control"
												placeholder="Website"
											/>
										</div>
									</div>
									<button
										class="btn btn-primary "
										style={{
											backgroundColor: "#FFC600",
											border: "#FFC600",
											borderRadius: "20px",
											float: "right",
										}}
									>
										Post Comment
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			{/* <Footer/> */}
		</>
	);
};

export default Blog4;
